import React, { useState, useEffect } from "react";
import { Chat } from "@progress/kendo-react-conversational-ui";
import { IntlProvider } from "@progress/kendo-react-intl";
import "./chatBoxGL.css";
import { useTranslation } from "react-i18next";

const ChatBoxGLPure = (props) => {
  const {
    user, //Array with users of the conversation
    placeholderChat, //PlaceHolder to input toolBar
    widthChat, //Width chat
    heightChat, //HeightChat
    createMessage, //Function to create message, use message and file
    conversation, //Information of messages that get from getWorkFlowExecutionMessage
  } = props;

  const { t } = useTranslation()
  const fileUpload = React.createRef();
  const [showToolbar, setShowToolbar] = useState(false);
  const [messages, setMessages] = useState(conversation);
  const [messagesActual, setMessagesActual] = useState({});
  const [fileContent, setFileContent] = useState("");

  //Function to add message in conversation
  const addNewMessage = (event) => {
    setMessages([...messages, event.message]);
    setMessagesActual(event.message);
  };

  //Function to upload pdf document
  const handleInputChange = (e) => {
    let file = e.target.files[0];
    let reader = new FileReader();
    setFileContent(file);
    reader.onloadend = (event) => {
      let message = {
        author: user,
        attachments: [
          {
            name: e.target.files[0].name,
            content: event.target ? event.target.result : "",
            contentType: "application/pdf",
            // contentType: "image/",
          },
        ],
      };
      setShowToolbar(false);
      setMessages([...messages, message]);
    };
    reader.readAsDataURL(file);
  };

  //send message and document to function create message
  useEffect(() => {
    if (
      (messagesActual && messagesActual.author) ||
      (fileContent && fileContent.name)
    ) {
      createMessage(messagesActual, fileContent);
      setMessagesActual({});
      setFileContent("");
    }
  }, [messagesActual, fileContent]);

  useEffect(() => {
    setMessages(conversation);
  }, [conversation]);

  //Message Template
  const MessageTemplate = (props) => {
    return (
      <>
        {props.item.text && props.item.text !== "undefined" ? (
          <div className="k-bubble">
            <div>{props.item.text}</div>
          </div>
        ) : null}
      </>
    );
  };

  /*Message box when send file*/
  const AttachmentTemplate = (props) => {
    return (
      <div className="k-card k-card-type-rich chatBox-boxContainer-pdf">
        {props.item && props.item.name ? (
          <div className="k-card-body quoteCard">
            <a href={props.item.site} download>
              {props.item.name}
            </a>
          </div>
        ) : (
          <div>{""}</div>
        )}
      </div>
    );
  };

  // const Toolbar = () => {
  //   return (
  //     <span>
  //       <input
  //         type="file"
  //         onChange={handleInputChange}
  //         // style={{
  //         //   display: "none",
  //         // }}
  //         ref={fileUpload}
  //       />
  //       <button
  //         className="sendimage k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-button k-button-md k-rounded-md k-button-solid k-button-solid-base-icon"
  //         onClick={() => fileUpload.current.click()}
  //       >
  //         {/* <span className="k-icon k-i-image" /> */}
  //       </button>
  //     </span>
  //   );
  // };

  /*Upload btns, send message and send file*/
  const uploadButton = (props) => {
    return (
      <React.Fragment>
        <input
          type="file"
          onChange={handleInputChange}
          style={{
            display: "none",
          }}
          ref={fileUpload}
        />
        <button
          className={
            "k-button k-button-md k-rounded-md k-button-flat k-button-flat-base k-button k-button-md k-rounded-md k-button-solid k-button-solid-base-icon"
          }
          onClick={() => fileUpload.current.click()}
        >
          <span
            className={"k-icon " + props.icon}
            style={{
              fontSize: "20px",
            }}
          />
        </button>
      </React.Fragment>
    );
  };

  // const Toolbar = () => {
  //   return (
  //     <span>
  //       <input
  //         type="file"
  //         onChange={handleInputChange}
  //         // style={{
  //         //   display: "none",
  //         // }}
  //         ref={fileUpload}
  //         // accept="application/pdf"
  //       />
  //       {/* <InputFileHLPure labelActive={false} labelInputFile={"hola"} /> */}
  //       <button
  //         className="sendimage k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-button k-button-md k-rounded-md k-button-solid k-button-solid-base-icon"
  //         onClick={() => fileUpload.current.click()}
  //       >
  //         <span className="k-icon k-i-image" />
  //       </button>

  //       <ButtonHLPure
  //         primary
  //         nameBtn={"Enviar"}
  //         onClick={() => props.messageInput()}
  //       />
  //     </span>
  //   );
  // };

  //ToolBar Chat
  const CustomChatMessage = (props) => (
    <React.Fragment>
      {props.messageInput}
      {uploadButton({
        icon: "k-i-clip-45",
      })}
      {props.sendButton}
    </React.Fragment>
  );

  return (
    <div className="chatBoxGLPure-container" xs={12} lg={12} md={12} sm={12}>
      <IntlProvider locale="es">
        <Chat
          user={user}
          messages={messages}
          onMessageSend={addNewMessage}
          placeholder={placeholderChat ?? t("chatBot.placeholder")}
          width={widthChat}
          height={heightChat}
          attachmentTemplate={AttachmentTemplate}
          messageBox={CustomChatMessage}
          messageTemplate={MessageTemplate}
          onActionExecute={createMessage}

        // showToolbar={showToolbar}
        // toolbar={<Toolbar />}
        // onToolbarActionExecute={() => setShowToolbar(!showToolbar)}
        // toolbar={<Toolbar />}
        />
      </IntlProvider>
    </div>
  );
};

export { ChatBoxGLPure as default };
